/**
 * Created by Karol Kluska on 13.06.18.
 */

angular
  .module('uib/template/datepickerPopup/popup.html', [])
  .run(overrideDatepickerPopupTemplate);

function overrideDatepickerPopupTemplate($templateCache) {
  $templateCache.put('uib/template/datepickerPopup/popup.html',
    '<div class="uib-datepicker-popup-wrapper" style="z-index: 1041;" fixed-element ng-if="isOpen" >' +
      '<ul role="presentation" class="uib-datepicker-popup dropdown-menu uib-position-measure" dropdown-nested ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">' +
        '<li ng-transclude></li>' +
        '<li ng-if="showButtonBar" class="uib-button-bar">' +
          '<span class="btn-group pull-left">' +
            '<button type="button" class="btn btn-sm btn-info uib-datepicker-current" ng-click="select(\'today\', $event)" ng-disabled="isDisabled(\'today\')">{{ getText(\'current\') }}</button>' +
            '<button type="button" class="btn btn-sm btn-danger uib-clear" ng-click="select(null, $event)">{{ getText(\'clear\') }}</button>' +
          '</span>' +
          '<button type="button" class="btn btn-sm btn-success pull-right uib-close" ng-click="close($event)">{{ getText(\'close\') }}</button>' +
        '</li>' +
      '</ul>' +
    '</div>' +
    '<div class="modal-backdrop" style="z-index: 1040;" ng-if="isOpen"></div>'
  );
}
